<template>
  <div class="classes">
      <v-container>
          <v-layout row>
              <v-flex v-for="clas in classes" :key="clas.sub" >
                  <v-hover v-slot:default="{ hover }" open-delay="200" >
                  <v-layout  class="my-6 mx-4" lg4 sm4 xs4 xl4 md4>
                      <v-card :elevation="hover ? 16 : 2" width="200px" height="220px" link :to="{name: 'Assignment',params:{id:clas.sub}}">
                          <v-card-item >
                              <v-card-content>
                                  <div style="width:198px;height:150px;" class="indigo accent-3">
                                  <v-card-title style="font-size:0.75em;">{{clas.sub}}</v-card-title>
                                  </div>
                                  <v-card-text class="text--primary">{{clas.faculty}}
                                      <v-tooltip small top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon class="ml-2" v-bind="attrs" v-on="on">book</v-icon>
                                        </template> <span>Notes</span>
                                      </v-tooltip> 
                                        <v-tooltip  small top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <router-link style="text-decoration:none;" :to="{name: 'Assignment',params:{id:clas.sub}}"> <v-icon  class="ml-3" v-bind="attrs" v-on="on">assignment</v-icon></router-link>
                                            </template> <span>Assignments</span>
                                        </v-tooltip>
                                </v-card-text>
                                  
                              </v-card-content>
                          </v-card-item>
                      </v-card>
                  </v-layout>
                  </v-hover>
              </v-flex>
          </v-layout>
      </v-container>
  </div>
</template>

<script>
export default {
data(){
    return {
        classes:[
            {sub:"Hospital Management",faculty:"Jena Catherine",year:"IV year CSE"},
            {sub:"Cryptography and Network Security",faculty:"Chakravarthi",year:"IV year CSE"},
            {sub:"Principles of Management",faculty:"Devi",year:"IV year CSE"},
            {sub:"Service Oriented Architecture",faculty:"Smitha",year:"IV year CSE"},
            {sub:"Cloud Computing",faculty:"Sundar",year:"IV year CSE"},
            {sub:"Human Computer Interaction",faculty:"Devi",year:"IV year CSE"},
        ]
    }
},
methods:{
    
}
}
</script>

<style>

</style>